import { Outlet } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import SocialSidebar from '../components/SocialSidebar'

export default function PublicLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <SocialSidebar />
      <main className="flex-grow" style={{ paddingTop: '68px' }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
